import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./UniqueSection.css";

gsap.registerPlugin(ScrollTrigger);

const features = [
  {
    title: "Accommodation & Stay",
    description:
      "Relax in Comfort, Celebrate in Style.",
    image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1736777339/Untitled_design_13_ksce6y.webp",
  },
  {
    title: "Marriage Venue",
    description:
      "A Stunning  Venue for Your Forever.",
    image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1736777339/Untitled_design_14_iuxw8q.webp",
  },
  {
    title: "Event Planning & Coordination for Weddings",
    description:
      "From Dream to Reality, We Make Your Wedding Perfect.",
    image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1735885225/4_wkdyeo.webp",
  },
  {
    title: "Decor & Floral Arrangements",
    description:
      "Transform Our Garden into Your Wedding Wonderland.",
    image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1735885225/2_ijgjd0.webp",
  },
  {
    title: "Swimming Pool",
    description:
      "Dive into Relaxation at Our Crystal-Clear Pool.",
    image: "https://res.cloudinary.com/dd8cg94ku/image/upload/v1735885226/5_uylp68.webp",
  },
  
];

const UniqueFeatures = () => {
  const containerRef = useRef(null);
  const wrapperRef = useRef(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  // Update screen size on resize
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // GSAP ScrollTrigger
  useEffect(() => {
    const ctx = gsap.context(() => {
      const totalWidth = wrapperRef.current.scrollWidth - containerRef.current.offsetWidth;
      gsap.to(wrapperRef.current, {
        xPercent: isDesktop ? -130 : -450, 
        ease: "none",
        scrollTrigger: {
          trigger: containerRef.current,
          pin: true,
          scrub: 1,
          start: "top top",
          end: `+=${totalWidth}`,
        },
      });
    }, containerRef);

    return () => ctx.revert();
  }, [isDesktop]);

  return (
    <div className="unique-features-container" ref={containerRef}>
      <h1 className="heading">Celebrate Love in Our Beautiful Garden</h1>
      <h2 className="subheading">Unforgettable Weddings, Timeless Memories</h2>
      <div className="unique-feature-wrapper" ref={wrapperRef}>
        {features.map((feature, index) => (
          <div className="unique-feature-box" key={index}>
            <img src={feature.image} alt={feature.title} className="feature-image" />
              <h3 className="feature-title">{feature.title}</h3>
            <div className="feature-overlay">
              <p className="feature-description">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UniqueFeatures;
